import { AuthorizationType } from './types';

/**
 * Per-method copy for the inline authorization flow.
 *
 * Every value is a translation key resolved through the `autorizace` namespace.
 * The keys below are NEW (the old wizard used `dialog.step1.*` / `dialog.step2.*`
 * / `code-input.*`) — see the migration note in the PR / README for the Czech
 * strings the CMS needs to provide.
 */
export interface MethodCopy {
	/** Subtitle shown when the method is selected, before a code is requested. */
	subtitleKey: string;
	/** Subtitle shown once a code has been sent (SMS / Mobile key only). */
	subtitleSentKey?: string;
	/**
	 * Primary action button: "send the code" for SMS / Mobile key,
	 * "continue to login" for the eID redirect.
	 */
	actionKey: string;
	/** Confirm-code button (SMS / Mobile key only). */
	confirmKey?: string;
	/** Placeholder for the one-time-password input (SMS / Mobile key only). */
	placeholderKey?: string;
	/** Subtitles contain the `{{identityUrl}}` interpolation (Identity portal link). */
	hasIdentityLink?: boolean;
	/** The method redirects to an external login instead of sending a code. */
	isRedirect?: boolean;
}

export const AUTHORIZATION_METHOD_COPY: Record<AuthorizationType, MethodCopy> =
	{
		[AuthorizationType.AUTENTIZACE]: {
			subtitleKey: 'authorization-type.autentizace.subtitle',
			actionKey: 'authorization-type.autentizace.continue',
			isRedirect: true,
		},
		[AuthorizationType.SMS]: {
			subtitleKey: 'authorization-type.sms.subtitle',
			subtitleSentKey: 'authorization-type.sms.subtitle-sent',
			actionKey: 'authorization-type.sms.send',
			confirmKey: 'authorization-type.sms.confirm',
			placeholderKey: 'authorization-type.sms.placeholder',
			hasIdentityLink: true,
		},
		[AuthorizationType.FCM]: {
			subtitleKey: 'authorization-type.fcm.subtitle',
			subtitleSentKey: 'authorization-type.fcm.subtitle-sent',
			actionKey: 'authorization-type.fcm.send',
			confirmKey: 'authorization-type.fcm.confirm',
			placeholderKey: 'authorization-type.fcm.placeholder',
		},
	};

/** Button label shared by all code-based methods to re-request a code. */
export const RESEND_KEY = 'dialog.resend';

/**
 * Resend button label during the cooldown countdown. Interpolates `{{seconds}}`
 * with the remaining time, e.g. "Poslat znovu za 15 s." (CMS-provided string).
 */
export const RESEND_COUNTDOWN_KEY = 'dialog.resend-countdown';

/** Seconds the resend button stays disabled after a code is (re)sent. */
export const RESEND_COUNTDOWN_SECONDS = 15;
